/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { QueryBuilder } from "mst-gql"
import { VisitEditedDtoModelType } from "./VisitEditedDtoModel"
import { VisitEditedDtoModelSelector, visitEditedDtoModelPrimitives } from "./VisitEditedDtoModel.base"

export type DriverVisitSubscriptionUnion = VisitEditedDtoModelType

export class DriverVisitSubscriptionModelSelector extends QueryBuilder {
  visitEditedDto(builder?: string | VisitEditedDtoModelSelector | ((selector: VisitEditedDtoModelSelector) => VisitEditedDtoModelSelector)) { return this.__inlineFragment(`VisitEditedDto`, VisitEditedDtoModelSelector, builder) }
}
export function selectFromDriverVisitSubscription() {
  return new DriverVisitSubscriptionModelSelector()
}

// provides all primitive fields of union member types combined together
export const driverVisitSubscriptionModelPrimitives = selectFromDriverVisitSubscription().visitEditedDto(visitEditedDtoModelPrimitives)